import { array, arrayOf, bool, func, shape, string } from 'prop-types'
import { AutoSizer, Column, Table, WindowScroller } from 'react-virtualized'
import React from 'react'
import Tile from './Tile'

const cellRenderer = (props) => {
  if (props.cellData === undefined) {
    return null
  }
  return (
    <Tile
      image={props.cellData.image}
      name={props.cellData.name}
      onClick={props.cellData.onClick}
      siteBuilding={props.cellData.site_building}
      url={props.cellData.url}
    />
  )
}
cellRenderer.defaultProps = {
  cellData: undefined,
}
cellRenderer.propTypes = {
  cellData: shape({
    image: string.isRequired,
    name: string.isRequired,
    onClick: func.isRequired,
    site_building: string.isRequired,
    url: string.isRequired,
  }),
}

const TilesView = (props) => {
  if (props.useWindowScroller) {
    return (
      <div className="tiles-view view">
        <WindowScroller>
          {({
            height,
            isScrolling,
            registerChild,
            scrollTop,
          }) => (
            <AutoSizer disableHeight>
              {({ width }) => {
                if (window.innerWidth >= 768) {
                  return (
                    <div ref={registerChild}>
                      <Table
                        autoHeight
                        disableHeader
                        width={width}
                        height={height}
                        headerHeight={0}
                        isScrolling={isScrolling}
                        rowHeight={((width / 3) * 0.82) + 32}
                        rowCount={props.rowsOfTiles.length}
                        rowGetter={({ index }) => {
                          const first = props.rowsOfTiles[index][0]
                          if (first !== undefined) {
                            first.onClick = props.onClick
                          }
                          const second = props.rowsOfTiles[index][1]
                          if (second !== undefined) {
                            second.onClick = props.onClick
                          }
                          const third = props.rowsOfTiles[index][2]
                          if (third !== undefined) {
                            third.onClick = props.onClick
                          }
                          return {
                            first,
                            second,
                            third,
                          }
                        }}
                        scrollTop={scrollTop}
                      >
                        <Column
                          cellRenderer={cellRenderer}
                          dataKey="first"
                          label="First"
                          width={(width / 3)}
                        />
                        <Column
                          cellRenderer={cellRenderer}
                          dataKey="second"
                          label="Second"
                          width={(width / 3)}
                        />
                        <Column
                          cellRenderer={cellRenderer}
                          dataKey="third"
                          label="Third"
                          width={(width / 3)}
                        />
                      </Table>
                    </div>
                  )
                }
              return (
                <div ref={registerChild}>
                  <Table
                    autoHeight
                    disableHeader
                    width={width}
                    height={height}
                    headerHeight={0}
                    isScrolling={isScrolling}
                    rowHeight={(width * 0.82) + 32}
                    rowCount={props.venues.length}
                    rowGetter={({ index }) => {
                      const first = props.venues[index]
                      if (first !== undefined) {
                        first.onClick = props.onClick
                      }
                      return {
                        first,
                      }
                    }}
                    scrollTop={scrollTop}
                  >
                    <Column
                      cellRenderer={cellRenderer}
                      dataKey="first"
                      label="First"
                      width={width}
                    />
                  </Table>
                </div>

              )
            }}
            </AutoSizer>
          )}
        </WindowScroller>
      </div>
    )
  }
  return (
    <div className="tiles-view view">
      <AutoSizer>
        {({ height, width }) => {
          if (window.innerWidth >= 768) {
            return (
              <Table
                disableHeader
                width={width}
                height={height}
                headerHeight={0}
                rowHeight={((width / 3) * 0.82) + 32}
                rowCount={props.rowsOfTiles.length}
                rowGetter={({ index }) => {
                  const first = props.rowsOfTiles[index][0]
                  if (first !== undefined) {
                    first.onClick = props.onClick
                  }
                  const second = props.rowsOfTiles[index][1]
                  if (second !== undefined) {
                    second.onClick = props.onClick
                  }
                  const third = props.rowsOfTiles[index][2]
                  if (third !== undefined) {
                    third.onClick = props.onClick
                  }
                  return {
                    first,
                    second,
                    third,
                  }
                }}
              >
                <Column
                  cellRenderer={cellRenderer}
                  dataKey="first"
                  label="First"
                  width={(width / 3)}
                />
                <Column
                  cellRenderer={cellRenderer}
                  dataKey="second"
                  label="Second"
                  width={(width / 3)}
                />
                <Column
                  cellRenderer={cellRenderer}
                  dataKey="third"
                  label="Third"
                  width={(width / 3)}
                />
              </Table>
            )
          }
          return (
            <Table
              disableHeader
              width={width}
              height={height}
              headerHeight={0}
              rowHeight={(width * 0.82) + 32}
              rowCount={props.venues.length}
              rowGetter={({ index }) => {
                const first = props.venues[index]
                if (first !== undefined) {
                  first.onClick = props.onClick
                }
                return {
                  first,
                }
              }}
            >
              <Column
                cellRenderer={cellRenderer}
                dataKey="first"
                label="First"
                width={width}
              />
            </Table>
          )
      }}
      </AutoSizer>
    </div>
  )
}
TilesView.propTypes = {
  onClick: func.isRequired,
  rowsOfTiles: arrayOf(array).isRequired,
  useWindowScroller: bool.isRequired,
  venues: arrayOf(shape({})).isRequired,
}

export default TilesView
